import theme from '@styles/theme';
export default {
  sectionHeader: {
    position: 'relative'
  },
  headerSliderContainer: {
    position: 'relative',
    height: '100%',
    '.swiper': {
      height: '100%'
    },
    '.slider-indicator': {
      bottom: ['16px', '16px', '108px', '108px', '24px'],
      transform: ['translateX(50%)', 'translateX(50%)', 'translateX(50%)', 'translateX(50%)', 'none']
    },
    '.swiper-slide': {
      opacity: '0',
      zIndex: theme.zIndex.documentUp
    },
    '.swiper-slide-active': {
      opacity: '1',
      zIndex: theme.zIndex.documentUp + 1
    }
  },
  frame: {
    color: theme.rawColors.neutralWhite,
    textAlign: ['center', 'center', 'center', 'center', 'right'],
    width: ['100%', '100%', '100%', '100%', '200px'],
    position: 'absolute',
    bottom: ['98px', '98px', '138px', '138px', '54px'],
    right: ['0', '0', '0', '0', '24px'],
    zIndex: theme.zIndex.documentUp + 1,
    fontSize: '13px',
    lineHeight: '140%',
    fontFamily: theme.fonts.uniformMedium,
    letterSpacing: '0.1em',
    textTransform: 'uppercase'
  }
};